import { render, staticRenderFns } from "./ReservationSlotAndArticleSelector.vue?vue&type=template&id=04ca5ef1&scoped=true"
import script from "./ReservationSlotAndArticleSelector.vue?vue&type=script&lang=js"
export * from "./ReservationSlotAndArticleSelector.vue?vue&type=script&lang=js"
import style0 from "./ReservationSlotAndArticleSelector.vue?vue&type=style&index=0&id=04ca5ef1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca5ef1",
  null
  
)

export default component.exports